import { Type } from 'class-transformer';
import { IsOptional, Length, ValidateNested } from 'class-validator';

import { SliderButtonSettingsModel } from './sliderButtonSettings.model';

export class SliderUpdateModel {
  @Length(32, 36)
  public imageId: string;

  @Length(3, 500)
  public header: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => SliderButtonSettingsModel)
  public buttonSettings?: SliderButtonSettingsModel;

  @IsOptional()
  @ValidateNested()
  @Type(() => SliderButtonSettingsModel)
  public secondButtonSettings?: SliderButtonSettingsModel;

  @IsOptional()
  @Length(3, 500)
  public description?: string;

  @IsOptional()
  @Length(32, 36)
  public linkedItemId?: string;
}
